/* istanbul ignore file -- covered by UploadGedcomCard.cy.js */
import React from 'react'
import { Separator, Card, H2, Paragraph, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { isTranslationAvailable } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import UploadTreeButton from './UploadTreeButton'

const HELP_ARTICLE_URL = 'https://www.familysearch.org/help/helpcenter/article/the-new-gedcom-upload-experience'

function UploadGedcomCard() {
  const [t] = useTranslation()

  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      <H2 size="H5" data-testid="upload-gedcom-card-title">
        {isTranslationAvailable('tree-import.manage-trees.create-tree-heading')
          ? t('tree-import.manage-trees.create-tree-heading')
          : t('tree-import.manage-trees.owned-groups-heading')}
      </H2>
      <Separator size="xs" />
      <Paragraph growY size="sm">
        {t('tree-import.manage-trees.upload-description')}{' '}
        <Link to={HELP_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
          {t('tree-import.gedcom-info-dialog.learn-more')}
        </Link>
      </Paragraph>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <UploadTreeButton emphasis="high" />
    </Card>
  )
}

export default UploadGedcomCard
